import React, { createContext, useState } from "react";
import axios from "axios";
import { Post, Get, imageUrl } from "../services/ApiCalls";
import { ErrorMessage, handleToastSuccess } from "../components";
import { useNavigate } from "react-router-dom";

export const GlobalContext = createContext();

let searchKey = "AIzaSyA2xZCCiYZDrWyTw93aLyYsJ68cExy6784";

const GlobalProvider = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [secondLoader, setSecondLoader] = useState(false);
  const [thirdLoader, setThirdLoader] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [loginData, setLoginData] = useState({});

  const [categoryData, setCategoryData] = useState([]);
  const [itemByCategoryData, setItemByCategoryData] = useState([]);
  const [otherItemByUserId, setOtherItemByUserId] = useState([]);
  const [userAllItemData, setUserAllItemData] = useState([]);
  const [calenderAvailibility, setCalenderAvailibility] = useState([]);
  const [checkAvailibility, setCheckAvailibility] = useState(false);
  const [specificItemData, setSpecificItemData] = useState({});
  const [itemByCategoryCount, setItemByCategoryCount] = useState({});
  const [promocode, setPromocode] = useState({});
  const [locationData, setLocationData] = useState({});

  const [itemComments, setItemComments] = useState([]);

  const [userWithdraw, setUserWithdraw] = useState([]);
  const [userBalance, setUserBalance] = useState(0);
  const [servicesFee, setServicesFee] = useState({});

  let navigate = useNavigate();

  function removeSpecificData() {
    setSpecificItemData({});
  }

  function renderSearch(e) {
    setSearchText(e);
  }

  function changeAvailibility(e) {
    setCheckAvailibility(e);
  }

  const [bySortValue, setBySortValue] = useState(1);
  const [listView, setListView] = useState(2);

  function changeBySort(sort, categoryData, locationData) {
    setBySortValue(sort);
    sort == 4 ? setListView(4) : setListView(2);
    if (searchText.length) search_item(searchText, sort, locationData);
    else if (categoryData?.id)
      get_item_by_category_id(categoryData?.id, sort, locationData);
  }

  function renderListView(status, categoryData, locationData) {
    setListView(status);
    if (status == 4) {
      setBySortValue(4);
      if (searchText.length) search_item(searchText, status, locationData);
      else if (categoryData?.id)
        get_item_by_category_id(categoryData?.id, status, locationData);
    }
  }

  const user_data = async () => {
    let userData = sessionStorage.getItem("user");
    userData && setLoginData(JSON.parse(userData));
  };

  const get_categories = async () => {
    setIsLoading(true);
    try {
      let response = await Get(`categories`);
      setCategoryData(response.data.message?.categories);
      // setCountData(response.data.countData);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setCategoryData([]);
    }
  };

  const create_item_by_user_id = async (payload) => {
    setIsLoading(true);
    try {
      let response = await Post(`items`, payload);
      navigate(-1);
      handleToastSuccess(response.data.message, true);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setCategoryData([]);
    }
  };

  const update_item_by_user_id = async (payload) => {
    setIsLoading(true);
    try {
      let response = await Post(`items/update`, payload);
      handleToastSuccess(response.data.message, true);
      navigate(-1);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setCategoryData([]);
    }
  };

  const get_item_by_user_id = async () => {
    setIsLoading(true);
    try {
      let response = await Get(`profile/items`);
      setUserAllItemData(response.data.items);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setCategoryData([]);
    }
  };

  const get_all_my_rent_item = async () => {
    setIsLoading(true);
    try {
      let response = await Get(`profile/rents`);
      console.log("response", response.data);
      setUserAllItemData(response.data.rents);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setCategoryData([]);
    }
  };

  const get_specific_item = async (id) => {
    setSecondLoader(true);
    try {
      let response = await Get(`items/${id}`);
      setSpecificItemData(response.data.item);
      setSecondLoader(false);
    } catch (error) {
      setSecondLoader(false);
      setCategoryData([]);
    }
  };

  const get_item_by_category_id = async (id, order, loc) => {
    let params =
      order == 4
        ? `categories/${id}&order=${order}&longitude=${loc.lng}&latitude=${loc.lat}`
        : `categories/${id}&order=${order}`;
    setIsLoading(true);
    try {
      let response = await Get(params);
      setItemByCategoryData(response.data.items);
      setItemByCategoryCount(response.data.links);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setCategoryData([]);
    }
  };

  const search_item = async (text, order, loc) => {
    let params =
      order == 4
        ? `search?term=${text}&order=${order}&longitude=${loc.lng}&latitude=${loc.lat}`
        : `search?term=${text}&order=${order}`;
    setIsLoading(true);
    try {
      let response = await Get(params);
      console.log("stem= ~ response", response);
      setItemByCategoryData(response.data.items);
      setItemByCategoryCount(response.data.links);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setCategoryData([]);
    }
  };

  const other_few_item_by_user_id = async (id) => {
    setOtherItemByUserId([]);
    setIsLoading(true);
    try {
      let response = await Get(`items/user/${id}`);
      setOtherItemByUserId(response.data.items);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const other_all_item_by_user_id = async (id, order) => {
    setIsLoading(true);
    try {
      let response = await Get(`items/user/${id}/all`);
      setItemByCategoryData(response.data.items);
      setItemByCategoryCount(response.data.links);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const create_rent_store = async (payload) => {
    setIsLoading(true);
    try {
      let response = await Post(`rent/store`, payload);
      navigate(-1);
      setPromocode({});
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  // check availability

  const check_availibility = async (id) => {
    setThirdLoader(true);
    try {
      let response = await Get(`rent/availability/${id}`);
      let data = response.data.rentals.map((val) => {
        return {
          day: parseInt(val.day),
          month: parseInt(val.month),
          year: parseInt(val.year),
        };
      });
      setCalenderAvailibility(data);
      setCheckAvailibility(true);
      setThirdLoader(false);
    } catch (error) {
      setCalenderAvailibility([]);
      setThirdLoader(false);
      setCheckAvailibility(false);
    }
  };

  // promo code

  const check_promo_code = async (payload, onClose) => {
    setThirdLoader(true);
    try {
      let response = await Post("promocodes/check", payload);
      setPromocode(response.data.promocode);
      onClose(false);
      setThirdLoader(false);
    } catch (error) {
      setThirdLoader(false);
    }
  };

  const get_item_comments = async (id) => {
    setThirdLoader(true);
    try {
      let response = await Get(`rating/${id}/comments`);
      setItemComments(response.data);
      setThirdLoader(false);
    } catch (error) {
      setThirdLoader(false);
    }
  };

  const checkLoation = async (latitude, longitude) => {
    axios
      .get(
        "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
          latitude +
          "," +
          longitude +
          "&key=AIzaSyA2xZCCiYZDrWyTw93aLyYsJ68cExy6784&sensor=true"
      )
      .then((data) => {
        var results = data.data;
        if (results.results[0]) {
          var city = "";
          var state = "";
          var country = "";
          var terrotary = "";

          var address_components = results.results[0].address_components;

          for (var i = 0; i < address_components.length; i++) {
            if (
              address_components[i].types[0] ===
                "administrative_area_level_1" &&
              address_components[i].types[1] === "political"
            ) {
              state = address_components[i].long_name;
            }
            if (
              address_components[i].types[0] === "locality" &&
              address_components[i].types[1] === "political"
            ) {
              city = address_components[i].long_name;
            }

            if (address_components[i].types[0] === "route" && terrotary == "") {
              terrotary = address_components[i].long_name;
            }

            if (address_components[i].types[0] === "country") {
              country = address_components[i].long_name;
            }
          }
          var address = {
            city: city,
            state: state,
            country: country,
            terrotary: terrotary,
            id: 1,
          };
          setLocationData(address);
        }
      })
      .catch((error) => {});
  };

  // withdrawel

  const get_balance = async () => {
    setSecondLoader(true);
    try {
      let response = await Get("profile/balance");
      setUserBalance(response.data.balance);
      setSecondLoader(false);
    } catch (error) {
      setSecondLoader(false);
    }
  };

  const get_all_withdrawel = async () => {
    setIsLoading(true);
    try {
      let response = await Get("profile/withdrawals");
      setUserWithdraw(response.data.withdrawals);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const post_withdrawel = async (payload, onCloseWithdrawModal) => {
    setThirdLoader(true);
    try {
      let response = await Post("profile/withdrawals/store", payload);
      setUserBalance(userBalance - payload.amount);
      get_all_withdrawel();
      onCloseWithdrawModal(false);
      setThirdLoader(false);
    } catch (error) {
      setThirdLoader(false);
    }
  };

  // tax amount

  const get_tax_amount = async (payload, onCloseWithdrawModal) => {
    setIsLoading(true);
    try {
      let response = await Get("settings");
      setServicesFee(response.data.settings);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  return (
    <GlobalContext.Provider
      value={{
        isLoading,
        secondLoader,
        thirdLoader,
        searchText,
        user_data,
        loginData,
        renderSearch,
        get_categories,
        categoryData,
        create_item_by_user_id,
        update_item_by_user_id,
        imageUrl,
        get_item_by_user_id,
        get_all_my_rent_item,
        get_specific_item,
        specificItemData,
        removeSpecificData,
        userAllItemData,
        get_item_by_category_id,
        search_item,
        itemByCategoryData,
        itemByCategoryCount,
        other_few_item_by_user_id,
        otherItemByUserId,
        other_all_item_by_user_id,
        create_rent_store,
        bySortValue,
        changeBySort,
        renderListView,
        listView,
        // availibility
        check_availibility,
        changeAvailibility,
        calenderAvailibility,
        checkAvailibility,
        // promocode
        check_promo_code,
        promocode,
        get_item_comments,
        itemComments,
        // check location
        checkLoation,
        locationData,
        // withdrawel
        get_balance,
        userBalance,
        get_all_withdrawel,
        userWithdraw,
        post_withdrawel,
        // tax
        get_tax_amount,
        servicesFee,
      }}
    >
      {props.children}
    </GlobalContext.Provider>
  );
};
export default GlobalProvider;
